"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeStakingConfig = exports.DEFAULT_PREPARE_FOR_REVOKE_COST = exports.NATIVE_STAKING_API_URL_DEV = exports.DEFAULT_NATIVE_STAKING_API_URL = exports.DEFAULT_BENEFICIARY = exports.DEFAULT_EXIT_AUTHORITY = exports.DEFAULT_STAKE_AUTHORITY = void 0;
const web3_js_1 = require("@solana/web3.js");
const bn_js_1 = __importDefault(require("bn.js"));
exports.DEFAULT_STAKE_AUTHORITY = new web3_js_1.PublicKey('stWirqFCf2Uts1JBL1Jsd3r6VBWhgnpdPxCTe1MFjrq');
exports.DEFAULT_EXIT_AUTHORITY = new web3_js_1.PublicKey('ex9CfkBZZd6Nv9XdnoDmmB45ymbu4arXVk7g5pWnt3N');
exports.DEFAULT_BENEFICIARY = new web3_js_1.PublicKey('opNS8ENpEMWdXcJUgJCsJTDp7arTXayoBEeBUg6UezP');
exports.DEFAULT_NATIVE_STAKING_API_URL = "https://native-staking.marinade.finance";
exports.NATIVE_STAKING_API_URL_DEV = "https://native-staking-dev.marinade.finance";
exports.DEFAULT_PREPARE_FOR_REVOKE_COST = new bn_js_1.default("2300000");
class NativeStakingConfig {
    constructor(overrides = {}) {
        this.connection = new web3_js_1.Connection('http://127.0.0.1:8899', 'confirmed');
        this.stakeAuthority = exports.DEFAULT_STAKE_AUTHORITY;
        this.exitAuthority = exports.DEFAULT_EXIT_AUTHORITY;
        this.nativeStakingApiUrl = exports.DEFAULT_NATIVE_STAKING_API_URL;
        this.beneficiary = exports.DEFAULT_BENEFICIARY;
        this.prepareForRevokeCost = exports.DEFAULT_PREPARE_FOR_REVOKE_COST;
        Object.assign(this, overrides);
    }
}
exports.NativeStakingConfig = NativeStakingConfig;
//# sourceMappingURL=config.js.map